export default {
      id: "form-preview-up-usage",
      viewBox: "0 0 375 188",
      url: __webpack_public_path__ + "icons.svg#form-preview-up",
      toString: function () {
        return this.url;
      }
    }